import React, { useEffect, useState } from "react";
import TimeTextField from '../../Components/timeTextField/TimeTextField';
import api from "../../services/api";
import Button from "../../Components/commonButton/commonButton";
import Slider from '../../Components/slider/slider';
import HeaderForms from "../../Components/headerForms/HeaderForms";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import './configView.css';

const ConfigView = () => {
    const [stop_start_time, setStopStartTime] = useState(0);
    const [count_piece_block, setCountPieceBlock] = useState(0);
    const [alert, setAlert] = useState(0);

    useEffect(() => {
        api.get('params').then((resp) => {
            const { TIME_STOP_SAVE, COUNT_PIECE_BLOCK, ALERT } = resp.data;
            setStopStartTime(TIME_STOP_SAVE);
            setCountPieceBlock(COUNT_PIECE_BLOCK);
            setAlert(ALERT);
        }).catch(err => {
            console.log(err)
        })

    }, []);

    const sendData = () => {
        const seconds_start_time = toSeconds(stop_start_time)
        const obj = {
            TIME_STOP_SAVE: seconds_start_time,
            COUNT_PIECE_BLOCK: ((count_piece_block) / 100).toFixed(2), ALERT: alert
        }
        api.post(`/params`, obj).then(({ status }) => {
            if (status == 200) {
                return window.location.reload()
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const toSeconds = (hms) => {
        const a = hms.split(':');
        const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
        return seconds;
    }
    return (
        <div className="config-container">
            <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column', alignItems: 'center' }}>
                <main className="config-main">
                    <HeaderForms text="Config." icon={faClock}></HeaderForms>
                    <div className="config-section">
                        <TimeTextField
                            id={"time-texfield"}
                            title="Tempo de parada 999"
                            autoFocus
                            seconds
                            value={stop_start_time}
                            min={1}
                            max={3}
                            parentCallback={setStopStartTime}
                        />
                        <Slider value={count_piece_block}
                            parentCallback={(value) => setCountPieceBlock((value))}
                            altType
                            title={"Percentual % de peças a mais"}
                        >
                        </Slider>
                        <div  >
                            <input  style={{minHeight:'20px',minWidth:'20px'}} type="checkbox" checked={alert} id="flexCheckDefault" onClick={()=>setAlert(!alert)} />
                            <label style={{marginLeft:'0.5vw'}}  for="flexCheckDefault">
                               {'Sirene ANDON'}
                            </label>
                        </div>
                        <div><Button size={false} title="Salvar" parentCallback={sendData} /></div>
                    </div>
                </main>
            </div>
        </div>
    )
}

export default ConfigView